<template>
    <main class="basket">
        <section class="product-detail">
            <div class="container-fluid cart-delivery">
                <div class="item-summary">
                    <div class="alert alert-danger empty" v-if="!count">
                        <strong>{{ _('Upozornenie') }}:</strong> {{ _('Váš nákupný košík je prázdny.') }}
                    </div>

                    <div class="item-title"><h4>Zhrnutie objednávky</h4></div>

                    <div class="table-wrapp">
                        <table>
                            <thead>
                                <tr>
                                    <th class="hidden-xs hidden-sm">Názov produktu</th>
                                    <th class="hidden-md hidden-lg">Produkt</th>

                                    <th class="dph-col">DPH</th>

                                    <th class="hidden-xs hidden-sm min-col">Cena za ks</th>
                                    <th class="hidden-md hidden-lg">Cena/ks</th>

                                    <th class="hidden-xs hidden-sm min-col">Cena spolu</th>
                                    <th class="hidden-md hidden-lg">Spolu</th>
                                    <th class="qty-col"></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, id) in basket">
                                    <td>
                                        <a v-bind:href="getProductAction(item.product)" target="_blank">{{ item.product.name }}</a>
                                        <span v-if="item.product.variant">{{ item.product.variant }}</span>
                                        <span v-for="(variant, $variantIndex) in getVariants(item.variants)">{{ variant.name }}<span class="variantGap" v-if="$variantIndex + 1 < getVariants(item.variants).length">,</span></span>
                                    </td>
                                    <td><div class="item-price">{{ item.product.vat }}%</div></td>
                                    <td><div class="item-price">{{ toPrice(itemPrice(item)) }} €</div></td>
                                    <td><div class="item-price">{{ toPrice(itemPrice(item) * item.quantity) }} €</div></td>
                                    <td class="detail-select">
                                        <div class="amount" v-bind:class="{ 'error' : hasProductNotEnoughtQty(item.product) }">
                                            <input type="number" min="1" max="9999" @focus="focusQuantity" @input="changeQuantity" :data-id="id" class="form-control" :value="item.quantity">
                                            <span class="hidden-xs">ks</span>
                                        </div>
                                    </td>
                                    <td><a @click.prevent="removeItem(id)" class="remove"><i class="fa fa-times" aria-hidden="true"></i></a></td>
                                </tr>
                                <tr v-for="(product) in freeProducts">
                                    <td><a v-bind:href="getProductAction(product)" target="_blank">{{ product.name }}</a> <span v-if="product.variant">{{ product.variant }}</span></td>
                                    <td><div class="item-price">{{ product.vat }}%</div></td>
                                    <td><div class="item-price free">{{ freeProductPrice }} €</div></td>
                                    <td><div class="item-price free">{{ freeProductPrice }} €</div></td>
                                    <td class="detail-select quantity"><div class="amount">1 ks</div></td>
                                </tr>
                                <tr v-for="product in getAdditional">
                                    <td><a v-bind:href="getProductAction(product)" target="_blank">{{ product.name }}</a> <span v-if="product.variant">{{ product.variant }}</span></td>
                                    <td><div class="item-price">{{ product.vat }}%</div></td>
                                    <td><div class="item-price free">{{ toPrice(product.price) }} €</div></td>
                                    <td><div class="item-price free">{{ toPrice(product.price * product.quantity) }} €</div></td>
                                    <td class="detail-select quantity"><div class="amount">{{ product.quantity }} ks</div></td>
                                </tr>
                                <tr v-if="cupoun">
                                    <td class="coupon-td">Zľavový kód
                                        <div>
                                            <span v-if="cupoun.free_delivery">Doprava zdarma</span>
                                            <span v-else-if="cupoun.discount_percent"><strong>{{ cupoun.discount_percent }} %</strong></span>
                                            <span v-else-if="cupoun.discount_price"><strong>{{ cupoun.discount_price }} €</strong></span>
                                            <span v-if="cupoun.product && hasCouponProductInBasket">, pre produkt <strong>{{ cupoun.product.name }}</strong></span>
                                            <span v-if="cupoun.price_limit > 0">, v minimálnej cene objednávky <strong>{{ cupoun.price_limit }} €</strong></span>
                                        </div>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td><div class="item-price blue">
                                        <span v-if="couponPrice > 0">-{{ couponPrice }} €</span>
                                    </div></td>
                                    <td></td>
                                </tr>
                                <tr class="summary-col">
                                    <td>Zhrnutie</td>
                                    <td colspan="4">
                                        <div class="item-price">{{ totalPriceWithoutTaxAndDiscount }} € bez DPH</div>
                                        <div class="item-price blue">{{ totalPriceWithDiscount }} € s DPH</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="cupoun-code" v-bind:class="{ success : code_status === true, error : code_status === false }">
                        <div class="item-title"><h4>{{ _('Zľavový kód') }}</h4></div>
                        <div class="row">
                            <div class="col-md-4">
                                <input type="text" v-model="code" :placeholder="_('Zadajte zľavový kód')" value="" class="form-control input-md">
                            </div>
                            <div class="col-md-8">
                                <span class="success"><i class="fa fa-check"></i> {{ _('Platný') }}</span>
                                <span class="error"><i class="fa fa-times"></i> {{ _('Neplatný kód') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="paymentOr">
                <div class="container">
                    <div class="clearfix payment-buttons">
                          <div class="text-right pull-right">
                            <button type="submit" @click="nextStep" class="btn blue-btn add-btn">{{ _('Pokračovať k osobným údajom') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script type="text/javascript">
    import Core from './core.js';
    import _ from 'lodash';

    export default {
        props : ['basket', 'bag', 'discount_code'],

        data(){
            return {
                errors : {},

                code : this.discount_code,
                cupoun : null,
                code_status : null,
                freeProductPrice : window.Laravel.data.free_product_price,
            };
        },

        mounted(){
            this.checkCode(this.code, true);
        },

        watch : {
            code(code){
                this.checkCode(code);
            },
        },

        computed: {
            count : Core.computed.count,
            baseTotalPrice : Core.computed.baseTotalPrice,
            totalPrice : Core.computed.totalPrice,
            totalPriceWithoutTax : Core.computed.totalPriceWithoutTax,
            totalPriceWithoutTaxAndDiscount : Core.computed.totalPriceWithoutTaxAndDiscount,
            totalPriceWithoutAdditional : Core.computed.totalPriceWithoutAdditional,
            totalPriceWithDiscount : Core.computed.totalPriceWithDiscount,
            totalPriceProfitable : Core.computed.totalPriceProfitable,
            getAdditionalPrice : Core.computed.getAdditionalPrice,
            getAdditionalPriceWithoutTax: Core.computed.getAdditionalPriceWithoutTax,
            hasCouponProductInBasket : Core.computed.hasCouponProductInBasket,
            couponPrice : Core.computed.couponPrice,
            discountPrice : Core.computed.discountPrice,
            freeProducts : Core.computed.freeProducts,
            getAdditional : Core.computed.getAdditional,
            isContractor : Core.computed.isContractor,
        },

        methods: {
            itemPrice : Core.methods.itemPrice,
            isCheckedBag(){
                for ( var key in this.basket )
                {
                    if ( this.basket[key].product.id == this.bag.id )
                        return true;
                }

                return false;
            },
            focusQuantity(e){
                e.target.select();
            },
            trans(key){
                return window.Laravel.trans.basket[key];
            },
            isCheckedBag(){
                for ( var key in this.basket )
                {
                    if ( this.basket[key].product.id == this.bag.id )
                        return true;
                }

                return false;
            },
            checkCode : Core.methods.checkCode,
            toPrice : Core.methods.toPrice,
            getVariants : Core.methods.getVariants,
            removeItem : Core.methods.removeItem,
            changeQuantity : _.debounce(function (e) {
                var quantity = e.target.value,
                    int = parseInt(e.target.value),
                    id = e.target.getAttribute('data-id');

                if ( int <= 0 || isNaN(int) )
                    quantity = e.target.value = 1;

                this.basket[id].quantity = quantity;

                $.get(window.Laravel.requests.basket.update, { item_id : id, quantity : quantity });
            }, 300),
            hasProductNotEnoughtQty : Core.methods.hasProductNotEnoughtQty,
            /*
             * Returns product path
             */
            getProductAction : Core.methods.getProductAction,
            /*
             * Nech step
             */
            nextStep(){
                this.errors = {};
                if ( this.count == 0 )
                    return this.$root.setMessage(__('Váš nákupný košík je prázdny.'));

                //Checks for product quantity
                for ( var key in this.basket )
                {
                    if ( this.hasProductNotEnoughtQty(this.basket[key].product) )
                    {
                        return this.$root.setMessage(this.trans('overlimit'), 'error');
                    }
                }

                if ( ! this.isCheckedBag() )
                    return this.askForBag();

                window.location.href = window.Laravel.requests.basket.billingInformaiton;
            },
            /*
             * Bag into basket
             */
            askForBag(){
                return this.$root.setMessage(__('Chcete tovar zabaliť do tašky?')+' <small>(+'+this.bag.price+' €)</small>', 'success', 'basket-bag');
            },
        },
    }
</script>